"use client";
import * as React from "react";
const SvgAddRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 11a1 1 0 1 0 2 0V7h4a1 1 0 1 0 0-2H7V1a1 1 0 1 0-2 0v4H1a1 1 0 1 0 0 2h4z", clipRule: "evenodd" }));
export {
  SvgAddRound as default
};
